<div [hidden]="consulta">
  <div class="row">
      <div class="col-lg-12" style="padding: 0px;">
          <section class="widget">
              <!-- título -->
              <header>
                  <h3>Administrar eliminación: {{tipoevaluacion.nombre}} {{tipoevaluacion.nivel}}</h3>
              </header>
              <div class="separador"></div>

          </section>
          <div class="divisor8"></div>

          <div class="row">

            <div class="col-lg-12" style="padding: 0px">
              <section class="widget">
                <div class="row" *ngIf="tipoevaluacion.tipoevaluacionid != 1">
                  <div class="col-3">
                    <dropdownCustom [titulo]="'Grado'"
                    [(ngModel)]="entidad.gradoid"
                    [buscar]="true" [opciones]="SelGrado"
                    displayValor="nombre" valorName="gradoid"
                    propiedad="gradoid"
                    [errorActivo]="errorActivo"
                    (ngModelChange)="SelGrupoList($event)"></dropdownCustom>
                  </div>
                  <div class="col-3">
                    <dropdownCustom [titulo]="'Grupo'"
                    [(ngModel)]="entidad.grupoid"
                    [buscar]="true" [opciones]="SelGrupo"
                    displayValor="nombre" valorName="grupoid"
                    propiedad="grupoid"
                    [errorActivo]="errorActivo"></dropdownCustom>
                  </div>
                  <div class="col-3">
                    <!-- <dropdownCustom [titulo]="'Departamento'"
                    [(ngModel)]="entidad.departamentoid"
                    [buscar]="true" [opciones]="SelDepartamento"
                    displayValor="nombre" valorName="departamentoid"
                    propiedad="departamentoid"
                    [errorActivo]="errorActivo"
                    (ngModelChange)="SelPuestoList($event)"></dropdownCustom> -->
                  </div>
                  <div class="col-2">
                    <!-- <dropdownCustom [titulo]="'Puesto'"
                    [(ngModel)]="entidad.puestoid"
                    [buscar]="true" [opciones]="SelPuesto"
                    displayValor="nombre" valorName="puestoid"
                    propiedad="puestoid"
                    [errorActivo]="errorActivo"></dropdownCustom> -->
                  </div>
                  <div class="col-1">
                    <button class="boton botonSM filled" (click)="getDatos(true)">Consultar</button>
                  </div>
                </div>
                <div class="row" *ngIf="tipoevaluacion.tipoevaluacionid == 1">
                  <div class="col-5">
                    <dropdownCustom [titulo]="'Departamento'"
                    [(ngModel)]="entidad.departamentoid"
                    [buscar]="true" [opciones]="SelDepartamento"
                    displayValor="nombre" valorName="departamentoid"
                    propiedad="departamentoid"
                    [errorActivo]="errorActivo"
                    (ngModelChange)="SelPuestoList($event)"></dropdownCustom>
                  </div>
                  <div class="col-5">
                    <dropdownCustom [titulo]="'Puesto'"
                    [(ngModel)]="entidad.puestoid"
                    [buscar]="true" [opciones]="SelPuesto"
                    displayValor="nombre" valorName="puestoid"
                    propiedad="puestoid"
                    [errorActivo]="errorActivo"></dropdownCustom>
                  </div>
                  <div class="col-2">
                    <button class="boton botonSM filled" (click)="getDatos(true)">Consultar</button>
                  </div>
                </div>
                <div class="row" >
                  <div class="col-lg-4 col-md-4 col-sm-12 col-12" *ngIf="dataTable.length > 0">
                    <button class="boton botonSM filled" (click)="eliminargrupoevaluaciones()">Eliminar todo</button>
                  </div>


                  <div class="col-12" *ngIf="evaluadoresestudiantes.indexOf(tipoevaluacion.tipoevaluacionid) !== -1">
                  <dx-data-grid
                  id="gridContaineralumno"
                  [dataSource]="dataTable"
                  [showBorders]="true"
                  [hoverStateEnabled]="true"
                  [showColumnHeaders]="true"
                >
                <dxo-search-panel
                [visible]="true"
                [width]="240"
                placeholder="{{'Buscar' | translate}}">
                </dxo-search-panel>
                  <dxi-column dataField="alumno"></dxi-column>
                  <dxi-column dataField="grado"></dxi-column>
                  <dxi-column dataField="grupo"></dxi-column>
                  <dxi-column dataField="matricula"></dxi-column>
                  <dxi-column
                  [allowExporting]="false"
                  cellTemplate="cellAcciones"
                  alignment="center"
                  [minWidth]="120">
                  </dxi-column>
                  <div *dxTemplate="let cell of 'cellAcciones'">
                    <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarevalalumno(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                        <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                    </a>
                  </div>
                  <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                  <div *dxTemplate="let eval of 'detail'">
                    <dx-data-grid
                    id="gridContainerevaluacion"
                    [dataSource]="eval.data.evaluaciones"
                    [showBorders]="true"
                  >
                    <dxi-column dataField="nombremateria" caption="Nombre materia"></dxi-column>
                    <dxi-column dataField="departamento"></dxi-column>
                    <dxi-column dataField="puesto"></dxi-column>
                    <dxi-column dataField="colaborador"></dxi-column>
                    <dxi-column
                    [allowExporting]="false"
                    cellTemplate="cellAcciones"
                    alignment="center"
                    [minWidth]="120">
                    </dxi-column>
                    <div *dxTemplate="let cell of 'cellAcciones'">
                      <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminareval(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                          <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                      </a>
                    </div>
                    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                    <div *dxTemplate="let pre of 'detail'">
                      <dx-data-grid
                      id="gridContainerpregunta"
                      [dataSource]="pre.data.preguntas"
                      [showBorders]="true"
                    >
                      <dxi-column dataField="pregunta"></dxi-column>
                      <dxi-column dataField="competencia"></dxi-column>
                      <dxi-column dataField="criterio"></dxi-column>
                      <dxi-column
                      [allowExporting]="false"
                      cellTemplate="cellAcciones"
                      alignment="center"
                      [minWidth]="120">
                      </dxi-column>
                      <div *dxTemplate="let cell of 'cellAcciones'">
                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarpregunta(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                            <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                        </a>
                    </div>
                    </dx-data-grid>
                    </div>
                  </dx-data-grid>
                  </div>
                </dx-data-grid>

                  </div>
                  <div class="col-12" *ngIf="evaluadorespadres.indexOf(tipoevaluacion.tipoevaluacionid) !== -1">
                    <dx-data-grid
                    id="gridContainerpadre"
                    [dataSource]="dataTable"
                    [showBorders]="true"
                    [hoverStateEnabled]="true"
                    [showColumnHeaders]="true"
                  >
                  <dxo-search-panel
                  [visible]="true"
                  [width]="240"
                  placeholder="{{'Buscar' | translate}}">
              </dxo-search-panel>
                    <dxi-column dataField="alumno" caption="Padre"></dxi-column>
                    <dxi-column dataField="grado"></dxi-column>
                    <dxi-column dataField="grupo"></dxi-column>
                    <dxi-column dataField="matricula"></dxi-column>
                    <dxi-column
                    [allowExporting]="false"
                    cellTemplate="cellAcciones"
                    alignment="center"
                    [minWidth]="120">
                    </dxi-column>
                    <div *dxTemplate="let cell of 'cellAcciones'">
                      <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarevalalumno(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                          <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                      </a>
                    </div>
                    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                    <div *dxTemplate="let eval of 'detail'">
                      <dx-data-grid
                      id="gridContainerevaluacion"
                      [dataSource]="eval.data.evaluaciones"
                      [showBorders]="true"
                    >
                      <dxi-column dataField="nombremateria" caption="Nombre materia"></dxi-column>
                      <dxi-column dataField="departamento"></dxi-column>
                      <dxi-column dataField="puesto"></dxi-column>
                      <dxi-column dataField="colaborador"></dxi-column>
                      <dxi-column
                      [allowExporting]="false"
                      cellTemplate="cellAcciones"
                      alignment="center"
                      [minWidth]="120">
                      </dxi-column>
                      <div *dxTemplate="let cell of 'cellAcciones'">
                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminareval(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                            <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                        </a>
                      </div>
                      <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                      <div *dxTemplate="let pre of 'detail'">
                        <dx-data-grid
                        id="gridContainerpregunta"
                        [dataSource]="pre.data.preguntas"
                        [showBorders]="true"
                      >
                        <dxi-column dataField="pregunta"></dxi-column>
                        <dxi-column dataField="competencia"></dxi-column>
                        <dxi-column dataField="criterio"></dxi-column>
                        <dxi-column
                        [allowExporting]="false"
                        cellTemplate="cellAcciones"
                        alignment="center"
                        [minWidth]="120">
                        </dxi-column>
                        <div *dxTemplate="let cell of 'cellAcciones'">
                          <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarpregunta(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                              <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                          </a>
                      </div>
                      </dx-data-grid>
                      </div>
                    </dx-data-grid>
                    </div>
                  </dx-data-grid>

                  </div>
                  <div class="col-12" *ngIf="evaluadortaller.indexOf(tipoevaluacion.tipoevaluacionid) !== -1">
                    <dx-data-grid
                    id="gridContaineralumno"
                    [dataSource]="dataTable"
                    [showBorders]="true"
                    [hoverStateEnabled]="true"
                    [showColumnHeaders]="true"
                  >
                  <dxo-search-panel
                  [visible]="true"
                  [width]="240"
                  placeholder="{{'Buscar' | translate}}">
              </dxo-search-panel>
                    <dxi-column dataField="alumno" caption="Nombre"></dxi-column>
                    <dxi-column dataField="evaluador" caption="Evaluador"></dxi-column>
                    <dxi-column dataField="grado"></dxi-column>
                    <dxi-column dataField="grupo"></dxi-column>
                    <dxi-column dataField="matricula"></dxi-column>
                    <dxi-column
                    [allowExporting]="false"
                    cellTemplate="cellAcciones"
                    alignment="center"
                    [minWidth]="120">
                    </dxi-column>
                    <div *dxTemplate="let cell of 'cellAcciones'">
                      <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarevalalumno(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                          <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                      </a>
                    </div>
                    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                    <div *dxTemplate="let eval of 'detail'">
                      <dx-data-grid
                      id="gridContainerevaluacion"
                      [dataSource]="eval.data.evaluaciones"
                      [showBorders]="true"
                    >
                      <dxi-column dataField="nombremateria" caption="Nombre materia"></dxi-column>
                      <dxi-column dataField="departamento"></dxi-column>
                      <dxi-column dataField="puesto"></dxi-column>
                      <dxi-column dataField="colaborador"></dxi-column>
                      <dxi-column
                      [allowExporting]="false"
                      cellTemplate="cellAcciones"
                      alignment="center"
                      [minWidth]="120">
                      </dxi-column>
                      <div *dxTemplate="let cell of 'cellAcciones'">
                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminareval(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                            <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                        </a>
                      </div>
                      <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                      <div *dxTemplate="let pre of 'detail'">
                        <dx-data-grid
                        id="gridContainerpregunta"
                        [dataSource]="pre.data.preguntas"
                        [showBorders]="true"
                      >
                        <dxi-column dataField="pregunta"></dxi-column>
                        <dxi-column dataField="competencia"></dxi-column>
                        <dxi-column dataField="criterio"></dxi-column>
                        <dxi-column
                        [allowExporting]="false"
                        cellTemplate="cellAcciones"
                        alignment="center"
                        [minWidth]="120">
                        </dxi-column>
                        <div *dxTemplate="let cell of 'cellAcciones'">
                          <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarpregunta(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                              <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                          </a>
                      </div>
                      </dx-data-grid>
                      </div>
                    </dx-data-grid>
                    </div>
                  </dx-data-grid>

                    </div>
                  <div class="col-12" *ngIf="tipoevaluacion.tipoevaluacionid == 1">
                    <dx-data-grid
                    id="gridContainercolaborador"
                    [dataSource]="dataTable"
                    [showBorders]="true"
                    [hoverStateEnabled]="true"
                    [showColumnHeaders]="true"
                  >
                  <dxo-search-panel
                  [visible]="true"
                  [width]="240"
                  placeholder="{{'Buscar' | translate}}">
              </dxo-search-panel>
                    <dxi-column dataField="nombre" caption="Departamento"></dxi-column>
                    <dxi-column
                    [allowExporting]="false"
                    cellTemplate="cellAcciones"
                    alignment="center"
                    [minWidth]="120">
                    </dxi-column>
                    <div *dxTemplate="let cell of 'cellAcciones'">
                      <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarevaluaciongrupodepartamento(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                          <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                      </a>
                    </div>
                    <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                    <div *dxTemplate="let eval of 'detail'">
                      <dx-data-grid
                      id="gridContainerevaluacion"
                      [dataSource]="eval.data.puestos"
                      [showBorders]="true"
                    >
                      <dxi-column dataField="puesto"></dxi-column>
                      <dxi-column dataField="colaborador"></dxi-column>
                      <dxi-column
                      [allowExporting]="false"
                      cellTemplate="cellAcciones"
                      alignment="center"
                      [minWidth]="120">
                      </dxi-column>
                      <div *dxTemplate="let cell of 'cellAcciones'">
                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarevaluacionesgrupocolaborador(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                            <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                        </a>
                      </div>
                      <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                      <div *dxTemplate="let pre of 'detail'">
                        <dx-data-grid
                        id="gridContainerpregunta"
                        [dataSource]="pre.data.evaluaciones"
                        [showBorders]="true"
                      >
                        <dxi-column dataField="colaborador"></dxi-column>
                        <dxi-column dataField="relacion"></dxi-column>
                        <dxi-column
                        [allowExporting]="false"
                        cellTemplate="cellAcciones"
                        alignment="center"
                        [minWidth]="120">
                        </dxi-column>
                        <div *dxTemplate="let cell of 'cellAcciones'">
                          <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarevaluacioncolaborador(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                              <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                          </a>
                      </div>
                      <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
                      <div *dxTemplate="let pre of 'detail'">
                        <dx-data-grid
                        id="gridContainerpregunta"
                        [dataSource]="pre.data.preguntas"
                        [showBorders]="true"
                      >
                        <dxi-column dataField="pregunta"></dxi-column>
                        <dxi-column dataField="competencia"></dxi-column>
                        <dxi-column dataField="criterio"></dxi-column>
                        <dxi-column
                        [allowExporting]="false"
                        cellTemplate="cellAcciones"
                        alignment="center"
                        [minWidth]="120">
                        </dxi-column>
                        <div *dxTemplate="let cell of 'cellAcciones'">
                          <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="eliminarevaluacionpreguntacolaborador(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                              <i class="fa fa-trash fa-lg" aria-hidden="true" style="color: red;"></i>
                          </a>
                      </div>

                      </dx-data-grid>
                      </div>
                      </dx-data-grid>
                      </div>
                    </dx-data-grid>
                    </div>
                  </dx-data-grid>

                  </div>
                </div>

                <div class="divisor20"></div>
                <div class="row margen">
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                                    (click)="Salir()">
                                <span> {{'Cancelar'}}</span>
                            </button>
                        </div>
                    </div>
                </div>
              </section>
            </div>


          </div>
      </div>


  </div>
</div>
